import {
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  Divider,
} from '@material-ui/core'
import RolesInput from '../RolesInput'
import React from 'react'
import HelpIcon from '@material-ui/icons/Help'
import { withStyles } from '@material-ui/core/styles'

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgb(235,235,235)',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #222',
    padding: '10px',
    minWidth: '400px',
  },
}))(Tooltip)

export default ({
  variableDialog,
  setvariableDialog,
  type,
  setoriginalvariableType,
  originalvariableType,
  databaseObjectModels,
}) => {
  const getPlaceholder = () => {
    switch (type) {
      case 'text':
        return 'Texte auto-rempli'
      case 'number':
        return 'Nombre auto-rempli'
      case 'date':
        return 'Date auto-remplie'
      case 'textformat':
        return 'Texte auto-remplie'

      default:
        return '/'
    }
  }

  React.useEffect(() => {
    switch (type) {
      case 'text':
        if (originalvariableType !== 'text') {
          setvariableDialog({
            ...variableDialog,
            placeholder: { value: '' },
            options: null,
          })
          setoriginalvariableType('text')
        }
        break
      case 'number':
        if (originalvariableType !== 'number') {
          setvariableDialog({
            ...variableDialog,
            placeholder: { value: 0 },
            options: null,
          })
          setoriginalvariableType('number')
        }
        break
      case 'date':
        if (originalvariableType !== 'date') {
          setvariableDialog({
            ...variableDialog,
            placeholder: { value: '' },
            options: null,
          })
          setoriginalvariableType('date')
        }
        break
      case 'textformat':
        if (originalvariableType !== 'textformat') {
          setvariableDialog({
            ...variableDialog,
            placeholder: { value: '' },
            options: null,
          })
          setoriginalvariableType('textformat')
        }
        break

      default:
        return 'd'
    }
  }, [type])

  return (
    (originalvariableType === 'text' ||
      originalvariableType === 'number' ||
      originalvariableType === 'date' ||
      originalvariableType === 'textformat') && (
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'start',
            backgroundColor: '#eee',
            margin: '0 20px',
            flexDirection: 'row',
            padding: '10px',
            width: '100%',
            border: '1px solid silver',
          }}
        >
          {getPlaceholder()} :{' '}
          <TextField
            variant="outlined"
            type={type}
            style={{
              backgroundColor: 'white',
              maxWidth: 400,
              marginLeft: 15,
            }}
            size="small"
            value={variableDialog?.placeholder?.value}
            onChange={(e) => {
              setvariableDialog({
                ...variableDialog,
                placeholder: {
                  value: type === 'number' ? +e.target.value : e.target.value,
                },
              })
            }}
          />
          {variableDialog?.type === 'number' && (
            <IconButton>
              <HtmlTooltip
                arrow
                placement="top-center"
                title={
                  <React.Fragment>
                    <div>
                      Pour insérer un nombre à virgules, une seule virgule est possible et vous avez
                      la possiblité de soit :
                    </div>
                    <ul>
                      <li>
                        Utiliser la touche du clavier <kbd>,</kbd> pour ajouter une virgule
                      </li>
                      <li>
                        Utiliser la touche du clavier <kbd>.</kbd> pour ajouter une virgule
                        seulement quand le curseur se trouve entre deux chiffres
                      </li>
                    </ul>
                  </React.Fragment>
                }
              >
                <HelpIcon />
              </HtmlTooltip>
            </IconButton>
          )}
          <div style={{ flex: 1 }}></div>
          <RolesInput
            style={{
              backgroundColor: 'white',
            }}
            variableDialog={variableDialog}
            setvariableDialog={setvariableDialog}
          ></RolesInput>
        </div>
      </>
    )
  )
}
